import filterNumbersModule from './filterNumbers';
import formatModule from './format';
import 'angular-translate';
import {checkHttpsAndWrapUrlsInCorsProxy, changeHttpToHttps, changeDNSPrefix} from '../common/util/url-util';

export default angular.module('app.filters', [
  filterNumbersModule.name,
  formatModule.name,
  'pascalprecht.translate'
])
  .filter('translateWith', function ($filter) {
    return function (options, input) {
      let key = _.isString(options) ? options : _.chain(options).keys().find(key => options[key]).value();
      let inputWithKey = input + '.' + key;
      let translation = $filter('translate')(input);
      let translationWithKey = $filter('translate')(inputWithKey);

      if (translationWithKey == inputWithKey) {
        return $filter('translate')(key, {value: translation});
      } else {
        return translationWithKey;
      }
    };
  })
  .filter('translateState', function ($filter) {
    return function (input) {
      let stateKey = `$state.${input}`;
      let stateTranslation = $filter('translate')(stateKey);

      if (stateTranslation == stateKey) {
        return $filter('translate')(input);
      } else {
        return stateTranslation;
      }
    }
  })
  .filter('translateCountry', function ($filter) {
    return function (value,fieldKey) {
      if (!fieldKey || (/country/i).test(fieldKey)) {
        return value.split(',').map(v => $filter('translate')(`countryCodes.${v}`)).join(', ');
      } else if (!fieldKey || (/ssps/i).test(fieldKey)) {
        return value;
      } else {
        switch(value) {
          case '0': return $filter('translate')('acquisitionSourceZeroKey');
          case 'Simplaex': return $filter('translate')('acquisitionSourceSimplaexKey');
          default: return value;
        }
      }
    }
  })
  .filter('numberToDayOfWeek', function ($filter) {
    return function (value,fieldKey) {
      switch(value) {
        case '1': return $filter('translate')('sunday');
        case '2': return $filter('translate')('monday');
        case '3': return $filter('translate')('tuesday');
        case '4': return $filter('translate')('wednesday');
        case '5': return $filter('translate')('thursday');
        case '6': return $filter('translate')('friday');
        case '7': return $filter('translate')('saturday');
      }
    }
  })
  .filter('shortMonthAndYear', function ($filter) {
    return function (value,fieldKey) {
      return moment(value, 'YYYY-MM').format('MMM YYYY');
    }
  })
  .filter('translateCount', function ($filter) {
    return function (count,oneKey,otherKey) {
      return $filter('translate')(count == 1 ? oneKey : otherKey);
    }
  })
  .filter('percentage', function ($filter) {
    return function (input, decimals) {
      return $filter('number')(input * 100, decimals) + '%';
    };
  })
  .filter('thousandsToK', function ($filter) {
    return function (input, decimals) {
      if (input >= 1000) {
        return $filter('number')(input / 1000, 1) + 'k';
      } else {
        return $filter('number')(input, decimals);
      }
    };
  })
  .filter('trustUrl', function ($sce) {
    return function (url) {
      return $sce.trustAsResourceUrl(url);
    };
  })
  .filter('chosableCreativeSizesAndTypes', function () {
    return function (sizes, chosenCreativeSizesAndTypes) {
      let chosableSizesAndTypes = [];
      let chosenSizesAndTypes = _.chain(chosenCreativeSizesAndTypes).map(sizeType => {
        if(sizeType.type == 'banner') return sizeType.size;
        // if(sizeType.type == 'video' || sizeType.type == 'native_banner' || sizeType.type == 'native_video') return sizeType.type;
      }).value();
      angular.forEach(sizes, function (value, key) {
        if (_.indexOf(chosenSizesAndTypes, value.value) == -1) {
          chosableSizesAndTypes.push(value);
        }
      })

      return chosableSizesAndTypes;
    };
  })
  .filter('capitalize', function () {
    return function (token) {
      if (token) {
        return token.charAt(0).toUpperCase() + token.slice(1);
      } else {
        return '';
      }
    }
  })
  .filter('toDate', function () {
    return function (date) {
      return moment(date).toDate();
    }
  })
  .filter('sortSelectedOnTop', function () {
    return function (elements) {
      if(!_.isEmpty(elements)) {
        let selectedElements = _.remove(elements, (element) => {
          return element.selected == true;
        });
        if(!_.isEmpty(selectedElements)) {
          elements = selectedElements.concat(elements);
        }
      }
      return elements;
    }
  })
  .filter('processWEBPUrls', function () {
    return function (apps) {
      return _.map(apps, (app) => {
        if (app.icon && app.icon.substr(app.icon.length -3, app.icon.length) == '-rw') {
          app.icon = app.icon.substr(0, app.icon.length -3);
        }
        return app;
      })
    }
  })
  .filter('segmentsListfilter', function () {
    return function (segments, statusFilterValue, nameFilterValue) {
      if (!_.isNull(nameFilterValue) && !_.isUndefined(nameFilterValue)) {
        nameFilterValue = nameFilterValue.toLowerCase();
        const filteredSegments = [];
        _.forEach(segments, (segment) => {
          if(segment.editing ||
              (statusFilterValue == 'all' || segment.status == statusFilterValue) && segment.name.toLowerCase().indexOf(nameFilterValue) != -1) {
            filteredSegments.push(segment);
          }
        });
        return filteredSegments;
      } else {
        return segments;
      }

    }
  })
  .filter('adaptNonCDNHttpsUrls', function (corsProxy) {
    return function (url) {
      return changeDNSPrefix(url);
    }
  })
  .filter('httpToHttps', function () {
    return function (url) {
      return changeHttpToHttps(url);
    }
  })
  .filter('emptyAsUndefined', function () {
    return function (value) {
      return _.isEmpty(value) ? undefined : value;
    }
  })



/** WEBPACK FOOTER **
 ** ./src/filters/filters.js
 **/